export default "__VITE_ASSET__Bb46GNYH__"